import { render, staticRenderFns } from "./AsCoachView.vue?vue&type=template&id=16b0e3fa&scoped=true"
import script from "./AsCoachView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsCoachView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsCoachView.vue?vue&type=style&index=0&id=16b0e3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0e3fa",
  null
  
)

export default component.exports